
const defaultMessage = "Ha sucedido un error en el sistema! Recargue su pagina e intente otra vez. Si el problema persiste, contacte con su administrador"

const doNone = () => {
  // do none
}

// Ver https://axios-http.com/docs/handling_errors
export function genericErrorHandler(error, customMessageOn422 = doNone) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
  
      switch(error.response.status) {
        case 401:
          return "Credenciales inválidas"
        case 403:
          return "No está autorizado"
        case 422:
          return on422(error, customMessageOn422)
      }
  
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);

      if(error.message === "Network Error")
        return "No tiene internet, problema de red."
  
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
    return defaultMessage
  }

function on422(error, customMessageOn422) {
  const data = error.response.data
  const message = customMessageOn422(data)

  if(message) return message
  
  const properties = {
    "date_time_range.start_greater_end": `inicio < fin, inicio: ${data.args.start}, fin: ${data.args.end}`,
    "not_found.entity_by_id": `No se encontro ${data.args.entity} con id: ${data.args.id}`,
    "not_found.alternative_in_question": `Alternativa no encontrada dentro de las alternativas de la pregunta, alternativeId: ${data.args.alternativeId}, question.id: ${data.args.id}`,
    "not_found.question": `No se encontro la pregunta, número: ${data.args.questionNumber}`,

    "exam.ended": `Ya finalizaste el examen`,
    "exam_event.ended": `Examen ya finalizo, finalizo a las: ${data.args.end}`
  }

  if(data.detail in properties) {
    return properties[data.detail]
  }

  return defaultMessage
}